import Constant from '@/Constant';
import wx from 'weixin-js-sdk';
import store from '@store/index';
export default {
  install(Vue, options) {
    Vue.prototype.linkFn = function (linkType, linkTarget) { //给自定义方法起个名  
      let ENV = Constant.assetBaseUrl;
      switch (linkType) {
        case '1':
          window.location.href = '/main/search?linkTarget=' + linkTarget + '&linkType=' + linkType;//商品搜索页
          break;
        case '2':
          window.location.href = '/main/brandHome?linkTarget=' + linkTarget + '&linkType=' + linkType;//店铺首页
          break;
        case '3':
          window.location.href = '/main/search?linkTarget=' + linkTarget + '&linkType=' + linkType;//店铺分类列表页
          break;
        case '4':
          window.location.href = '/main/goodsDetail?linkTarget=' + linkTarget + '&linkType=' + linkType;//商品详情
          break;
        case '5':
          //to do
          break;
        case '6':
          //to do
          break;
        case '93':
          //to do
          break;
        case '94':
          //to do
          break;
        case '95':
          window.location.href = '/main/physicalStores?linkTarget=' + linkTarget + '&linkType=' + linkType;//店铺门店页
          break;
        case '96':
          window.location.href = '/main/physicalStores?linkTarget=' + linkTarget + '&linkType=' + linkType;//实体门店页
          break;
        case '97':
          //diy页面
          break;
        case '98':
          if (linkTarget.indexOf('http://') < 0) {
            linkTarget = "http://" + linkTarget;
          }
          window.location.href = linkTarget;
          break;
        case '99':
          //to do
          break;
        case 'project':
          window.location.href = 'http://www.cqmxjt.cn/index.php?m=content&c=index&a=lists&catid=80';
          break;
        case 'fitting':
          window.location.href = '/fitting/role';
          break;
        case 'oa':
          window.location.href = 'http://oa.mexingroup.com:9999';
        default:
          break;
      }
    }

  }
}

/**
 * 微信分享初始化
 */
export const initWxShare = function (url) {
  //--------微信分享初始化
  store._actions.getWxJsSdkConfig[0]([url]).then(wxTarget => {
    wxTarget.debug = false;
    //微信配置
    var wxconfig = {
      appId: wxTarget.appId,
      debug: wxTarget.debug,
      nonceStr: wxTarget.nonceStr,
      signature: wxTarget.signature,
      timestamp: wxTarget.timestamp,
      jsApiList: wxTarget.jsApiList
    }
    wx.config(wxTarget);
  }).then(() => {

    let shareTitle = document.title;
    let shareUrl = location.href;
    let shareDesc = location.href;
    let shareImgUrl = 'http://' + location.host + '/static/images/meixin_logo.jpg';
    wx.ready(function () {
      //分享到朋友圈
      wx.onMenuShareTimeline({
        title: shareTitle, // 分享标题
        link: shareUrl, // 分享链接
        imgUrl: shareImgUrl, // 分享图标
        success: function () {
        }
      });
      //分享给朋友
      wx.onMenuShareAppMessage({
        title: shareTitle, // 分享标题
        desc: shareDesc, // 分享描述
        link: shareUrl, // 分享链接
        imgUrl: shareImgUrl, // 分享图标
        type: '', // 分享类型,music、video或link，不填默认为link
        dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
        success: function () {
        }
      });
      /*分享到qq*/
      wx.onMenuShareQQ({
        title: shareTitle, // 分享标题
        desc: shareDesc, // 分享描述
        link: shareUrl, // 分享链接
        imgUrl: shareImgUrl, // 分享图标
        success: function () {
          // 用户确认分享后执行的回调函数
        },
        cancel: function () {
          // 用户取消分享后执行的回调函数
        }
      });
      //分享到腾讯微博
      wx.onMenuShareWeibo({
        title: shareTitle, // 分享标题
        desc: shareDesc, // 分享描述
        link: shareUrl, // 分享链接
        imgUrl: shareImgUrl, // 分享图标
        success: function () {
          // 用户确认分享后执行的回调函数
        },
        cancel: function () {
          // 用户取消分享后执行的回调函数
        }
      });
      //分享到qq空间
      wx.onMenuShareQZone({
        title: shareTitle, // 分享标题
        desc: shareDesc, // 分享描述
        link: shareUrl, // 分享链接
        imgUrl: shareImgUrl, // 分享图标
        success: function () {
          // 用户确认分享后执行的回调函数
        },
        cancel: function () {
          // 用户取消分享后执行的回调函数
        }
      });
    });
  });
  //----微信分享初始化结束
}


// WEBPACK FOOTER //
// ./src/common/js/common.js